import React from 'react';
import { X } from 'lucide-react';

interface FilterBadgeProps {
    label: string;
    value: string;
    onRemove: () => void;
}

const FilterBadge: React.FC<FilterBadgeProps> = ({ label, value, onRemove }) => {
    return (
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-full text-sm font-medium transition-all hover:bg-blue-100">
            <span className="font-semibold">{label}:</span>
            <span>{value}</span>
            <button
                onClick={onRemove}
                className="ml-1 hover:bg-blue-200 rounded-full p-0.5 transition-colors"
                aria-label={`Remove ${label} filter`}
            >
                <X className="h-3.5 w-3.5" />
            </button>
        </div>
    );
};

export default FilterBadge;
